import React from 'react';
import { useTranslation } from '../../i18n';
import { Modal, QRCodeDisplay } from '../shared';

interface LobbyQrZoomModalProps {
  isOpen: boolean;
  roomName: string;
  onClose: () => void;
}

export const LobbyQrZoomModal: React.FC<LobbyQrZoomModalProps> = ({
  isOpen,
  roomName,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentStyle={{
        maxWidth: '95%',
        maxHeight: '95%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem',
        gap: '1.5rem',
      }}
    >
      <div className="qr-modal-room-code">
        {t('lobby.gameSelection.qrModalRoom', { roomName })}
      </div>
      <QRCodeDisplay
        roomName={roomName}
        size={600}
        showLabel={false}
        bare
        className="qr-modal-code"
      />
      <div className="qr-modal-scan-text">{t('lobby.gameSelection.qrModalScan')}</div>
    </Modal>
  );
};
